// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"22cee864","453":"6d6c8da3"}[chunkId] + ".chunk.js";
};